module.exports = __webpack_public_path__ + "img/karma.d6e3dba2.png";